export default function NotFound() {
  return (
    <img
      src="./images/Oops! 404 Error with a broken robot-rafiki.svg"
      alt="not found"
      className="w-full"
    ></img>
  );
}
